// this file is only displayed for smartPOS integrations

import comment from '../../snippets/comment';
import {locales} from '../sampleLocations';

const createIntent = (country) => {
  const currency = locales[country].currency;
  const pmTypes =
    country === 'CA'
      ? `['card_present', 'interac_present']`
      : `['card_present']`;
  return `
  {+create-intent}
  {span response create-intent}$intent{/span} = \\Stripe\\PaymentIntent::create([
    'amount' => $json_obj->amount,
    'currency' => '${currency}',
    'payment_method_types' => ${pmTypes},
    'capture_method' => 'manual',
  ]);
  echo json_encode(array('client_secret' => $intent->client_secret));
  {/create-intent}
`;
};

export default ({keys, merchant, country}) => `<?php

require 'vendor/autoload.php';
${comment && comment(merchant)}
\\Stripe\\Stripe::setApiKey('${keys.secret}');

header('Content-Type: application/json');

try {
  $json_str = file_get_contents('php://input');
  $json_obj = json_decode($json_str);

  // For Terminal payments, the 'payment_method_types' parameter must include
  // 'card_present' and the 'capture_method' must be set to 'manual'
  ${createIntent(country)}

} catch (Error $e) {
  http_response_code(500);
  echo json_encode(['error' => $e->getMessage()]);
}`;
